const getUserLocation = () => window.webShellClient.userLocation?.get();

export const getUserCountryCode = () => getUserLocation()?.country;

export const getUserState = () => getUserLocation()?.state;
